import { Injectable } from '@angular/core';
import saveAs from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class FileUtilsService {
  constructor() {}

  downloadBlob(blob: Blob, filename: string): void {
    saveAs(blob, filename);
  }

  base64ToBlob(base64Content: string, contentType: string = 'application/pdf'): Blob {
    const byteCharacters = atob(base64Content);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }
}
